import { graphql } from '@mp/graphql/generated';

export const OrientationJobsListItemGql = graphql(`
  fragment OrientationJobsListItemJob on Job {
    approved_clock_in
    approved_clock_out
    current_ends_time
    current_starts_time
    guaranteed_minimum_hours
    id
    starts_date
    status
    job_billing_sums {
      payout_total_amount_cents
    }
    location {
      address_city
      address_zip
      name
      timezone_lookup
    }
    positions {
      display_name
    }
    specialties {
      label
    }
  }
`);
